import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import Serviced from 'webapp/models-custom/serviced';

export interface ConnectSelectionData {
	dataSourceTypeId: number;
}

export default class ConnectSelection extends Serviced {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	dataSourceTypeId: ConnectSelectionData['dataSourceTypeId'];

	isConnectSelection = true as const; // used when filtering sources in the datamanager-connected
	declare isConnectRequest?: false; // tells it apart from a ConnectRequest in that list
	declare activeFilter?: string[]; // set by the filter-sort, like on sources

	constructor(connectRequestData: ConnectSelectionData) {
		super();

		this.dataSourceTypeId = connectRequestData.dataSourceTypeId;
	}

	get createdById() {
		return this.currentUserService.numericId;
	}

	get isMine() {
		return true; // selections are always the current user's
	}

	get title() {
		return this.sourceType?.name;
	}

	get sourceType() {
		return this.mmSourceTypesService.findModelById(this.dataSourceTypeId);
	}
}
